import React, { useCallback, useRef, useState } from 'react'
import { BetslipContext } from '../BetslipConf';
import { getBaseURL, isLoadedInIframe } from '../../utils';
import { xs_isMobile } from '../../..';
import { getLabel } from '../../../InitData';

function ReservationDetailShareWh(props) {
    const betslipContext = React.useContext(BetslipContext);
    const [labelCopy, setLabelCopy] = useState('Copia')
    const reservationCode = betslipContext.reservationDetailCode;

    const getTicketURL = useCallback((code) => {
        const baseURL = getBaseURL();
        return `${baseURL}/betslip?reservationCode=${code}`;
    }, []);

    const ticketUrl = getTicketURL(reservationCode)
    const message = getLabel('reservation_detail.share_ticket')

    const text = `${message} ${window.encodeURIComponent(ticketUrl)}`.replace(/ /g, '%20');
    const whatsappUrl = xs_isMobile ? `whatsapp://send?text=${text}` : `https://web.whatsapp.com/send?text=${text}`;
    const telegramUrl = `https://t.me/share/url?url=${ticketUrl}&text=${message}`;
    const copyLinkRef = useRef(null)

    function handleClose() {
        betslipContext.toggleReservationDetail();
        props.onGoBack(false);
    }

    function handleClick() {
        copyLinkRef.current.select()
        copyLinkRef.current.setSelectionRange(0, 99999); // For mobile devices
        navigator.clipboard.writeText(copyLinkRef.current.value);

        setLabelCopy(getLabel('betslip.reservation.copied'))
        setTimeout(() => {
            setLabelCopy(getLabel('betslip.reservation.copy'))
        }, 2000);
    }

    return (
        <div className='reservationDetailShare--wrapper'>
            <div className="header">
                <span className="title">{getLabel('betslip.reservation.share_bet')}</span>
                <span className="close-button pointer" onClick={handleClose} >
                    <i className="fa fa-times"></i>
                </span>
            </div>
            <div className='shareSocial__body--wrapper'>
                <div className='shareLink--wrapper'>
                    <div className='subItem__header'>{getLabel('betslip.reservation.share_link')}</div>
                </div>
                <div className='shareLink'>
                    <input ref={copyLinkRef} readOnly className='shareLink--input' type="text" defaultValue={ticketUrl} id="copyLink" />
                    <button className='shareLink--btn' onClick={handleClick}>{labelCopy}</button>
                </div>
                <div className='shareLink--wrapper'>
                    <div className='subItem__header'>{getLabel('betslip.reservation.share_viaChat')}</div>
                </div>
                <div className='shareLink--social'>
                    <a href={telegramUrl} target='_blank' className='shareLink--telegram'>Telegram</a>
                    <a href={whatsappUrl} target='_blank' className='shareLink--whatsapp'>Whatsapp</a>
                </div>
            </div>
        </div>
    )
}

export default ReservationDetailShareWh
